"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Rates;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
require("../css/rate-slide.css");
var _reactStepzilla = _interopRequireDefault(require("react-stepzilla"));
var _reactRedux = require("react-redux");
var _LoanPurpose = _interopRequireDefault(require("./LoanPurpose"));
var _PurchasePrice = _interopRequireDefault(require("./PurchasePrice"));
var _DownPayment = _interopRequireDefault(require("./DownPayment"));
var _RefinanaceForm = _interopRequireDefault(require("./RefinanaceForm"));
var _CashOutRefinanceForm = _interopRequireDefault(require("./CashOutRefinanceForm"));
var _ZipCode = _interopRequireDefault(require("./ZipCode"));
var _CountryState = _interopRequireDefault(require("./CountryState"));
var _StateCounty = _interopRequireDefault(require("./StateCounty"));
var _CreditScore = _interopRequireDefault(require("./CreditScore"));
var _PropertyType = _interopRequireDefault(require("./PropertyType"));
var _PropUsed = _interopRequireDefault(require("./PropUsed"));
var _VARatesPoints = _interopRequireDefault(require("./VARatesPoints"));
var _LowerRates = _interopRequireDefault(require("./LowerRates"));
var _RatesData = _interopRequireDefault(require("./RatesData"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
    06/14/2020 - Suhas

    This is a Rate-Quote slider home page.
    From here all the other sub-pages in Rate Quote slider are shown in a step-form.

    New sub-forms are added in this aprt from its original implementation:
    1. Down Payment is separated from PurchasePrice
    2. County is separated from the CountryState form
*/

function Rates(props) {
  // const {state} = useRatesContext();
  // const type = state.type;
  // const zipCodeRedux = state.zipCode;
  const type = (0, _reactRedux.useSelector)(state => state.nameReducer.type);
  const state = (0, _reactRedux.useSelector)(state => state.nameReducer);
  const zipCodeRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.zipCode);
  const branchLeadSource = props.leadSource;
  const steps = [{
    name: 'LoanPurpose',
    component: /*#__PURE__*/_react.default.createElement(_LoanPurpose.default, {
      leadSource: branchLeadSource
    })
  }];
  const PurchaseSteps = [{
    name: 'LoanPurpose',
    component: /*#__PURE__*/_react.default.createElement(_LoanPurpose.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'purchasePrice',
    component: /*#__PURE__*/_react.default.createElement(_PurchasePrice.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'ZipCode',
    component: /*#__PURE__*/_react.default.createElement(_ZipCode.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'CreditScore',
    component: /*#__PURE__*/_react.default.createElement(_CreditScore.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'PropertyType',
    component: /*#__PURE__*/_react.default.createElement(_PropertyType.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'PropertyUsed',
    component: /*#__PURE__*/_react.default.createElement(_PropUsed.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'VARatesPoints',
    component: /*#__PURE__*/_react.default.createElement(_VARatesPoints.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'RatesData',
    component: /*#__PURE__*/_react.default.createElement(_RatesData.default, {
      leadSource: branchLeadSource,
      phoneNumber: props.phoneNumber,
      phoneText: props.phoneText,
      this: true
    })
  }];
  const FullDocsSteps = [{
    name: 'LoanPurpose',
    component: /*#__PURE__*/_react.default.createElement(_LoanPurpose.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'CurrentLoanBalance',
    component: /*#__PURE__*/_react.default.createElement(_RefinanaceForm.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'ZipCode',
    component: /*#__PURE__*/_react.default.createElement(_ZipCode.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'CreditScore',
    component: /*#__PURE__*/_react.default.createElement(_CreditScore.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'PropertyType',
    component: /*#__PURE__*/_react.default.createElement(_PropertyType.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'PropertyUsed',
    component: /*#__PURE__*/_react.default.createElement(_PropUsed.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'VARatesPoints',
    component: /*#__PURE__*/_react.default.createElement(_VARatesPoints.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'RatesData',
    component: /*#__PURE__*/_react.default.createElement(_RatesData.default, {
      leadSource: branchLeadSource,
      phoneNumber: props.phoneNumber,
      phoneText: props.phoneText,
      this: true
    })
  }];
  const CashOutRefiSteps = [{
    name: 'LoanPurpose',
    component: /*#__PURE__*/_react.default.createElement(_LoanPurpose.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'CashOutFinanceForm',
    component: /*#__PURE__*/_react.default.createElement(_CashOutRefinanceForm.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'ZipCode',
    component: /*#__PURE__*/_react.default.createElement(_ZipCode.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'CreditScore',
    component: /*#__PURE__*/_react.default.createElement(_CreditScore.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'PropertyType',
    component: /*#__PURE__*/_react.default.createElement(_PropertyType.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'PropertyUsed',
    component: /*#__PURE__*/_react.default.createElement(_PropUsed.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'VARatesPoints',
    component: /*#__PURE__*/_react.default.createElement(_VARatesPoints.default, {
      leadSource: branchLeadSource
    })
  }, {
    name: 'RatesData',
    component: /*#__PURE__*/_react.default.createElement(_RatesData.default, {
      leadSource: branchLeadSource,
      phoneNumber: props.phoneNumber,
      phoneText: props.phoneText,
      this: true
    })
  }];

  // Add the state and county steps if the user provided a zipcode
  if (zipCodeRedux === "" || zipCodeRedux === undefined || zipCodeRedux === null) {
    FullDocsSteps.splice(3, 0, {
      name: 'CountryState',
      component: /*#__PURE__*/_react.default.createElement(_CountryState.default, {
        leadSource: branchLeadSource
      })
    });
    CashOutRefiSteps.splice(3, 0, {
      name: 'CountryState',
      component: /*#__PURE__*/_react.default.createElement(_CountryState.default, {
        leadSource: branchLeadSource
      })
    });
    FullDocsSteps.splice(4, 0, {
      name: 'StateCounty',
      component: /*#__PURE__*/_react.default.createElement(_StateCounty.default, {
        leadSource: branchLeadSource
      })
    });
    CashOutRefiSteps.splice(4, 0, {
      name: 'StateCounty',
      component: /*#__PURE__*/_react.default.createElement(_StateCounty.default, {
        leadSource: branchLeadSource
      })
    });
  }

  // Add the downpayment step if the user provided a purchase price
  if (state.purchasePrice > 0) {
    PurchaseSteps.splice(2, 0, {
      name: 'DownPaymentForm',
      component: /*#__PURE__*/_react.default.createElement(_DownPayment.default, {
        leadSource: branchLeadSource
      })
    });

    // Add the state and county steps if the user provided a zipcode
    if (zipCodeRedux === "" || zipCodeRedux === undefined || zipCodeRedux === null) {
      PurchaseSteps.splice(4, 0, {
        name: 'CountryState',
        component: /*#__PURE__*/_react.default.createElement(_CountryState.default, {
          leadSource: branchLeadSource
        })
      });
      PurchaseSteps.splice(5, 0, {
        name: 'StateCounty',
        component: /*#__PURE__*/_react.default.createElement(_StateCounty.default, {
          leadSource: branchLeadSource
        })
      });
    }
  }
  if (state.purchasePrice <= 0) {
    if (zipCodeRedux === "" || zipCodeRedux === undefined || zipCodeRedux === null) {
      PurchaseSteps.splice(3, 0, {
        name: 'CountryState',
        component: /*#__PURE__*/_react.default.createElement(_CountryState.default, {
          leadSource: branchLeadSource
        })
      });
      PurchaseSteps.splice(4, 0, {
        name: 'StateCounty',
        component: /*#__PURE__*/_react.default.createElement(_StateCounty.default, {
          leadSource: branchLeadSource
        })
      });
    }
  }
  if (branchLeadSource !== "NET007" && branchLeadSource !== "TEXAS-TV" && branchLeadSource !== "NET049") {
    PurchaseSteps.splice(PurchaseSteps.length - 1, 0, {
      name: 'LowerRates',
      component: /*#__PURE__*/_react.default.createElement(_LowerRates.default, {
        leadSource: branchLeadSource
      })
    });
    FullDocsSteps.splice(FullDocsSteps.length - 1, 0, {
      name: 'LowerRates',
      component: /*#__PURE__*/_react.default.createElement(_LowerRates.default, {
        leadSource: branchLeadSource
      })
    });
    CashOutRefiSteps.splice(CashOutRefiSteps.length - 1, 0, {
      name: 'LowerRates',
      component: /*#__PURE__*/_react.default.createElement(_LowerRates.default, {
        leadSource: branchLeadSource
      })
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "justify-content-center my-2"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "step-progress text-center"
  }, /*#__PURE__*/_react.default.createElement(_reactStepzilla.default, {
    steps: type === "PURCHASE" ? PurchaseSteps : type === "FULL DOCS REFI" ? FullDocsSteps : type === "CASH OUT REFI" ? CashOutRefiSteps : steps,
    showSteps: false,
    nextButtonText: ">>",
    backButtonText: "<<",
    showNavigation: true,
    preventEnterSubmission: true,
    dontValidate: false,
    nextTextOnFinalActionStep: "Submit",
    prevBtnOnLastStep: false
  })))));
}